import { HttpContext } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { LANG_TOKEN, RequestOptions } from "@3volutionsag/ngx-rooms-lib";

import { SERVICEUSER_TOKEN } from "../authentication/auth.interceptor";
import { ConfigurationState } from "../configuration/state/configuration.state";

@Injectable({
	providedIn: "root",
})
export class HttpRequestHelperService {
	private store = inject(Store);

	/**
	 * Prepares request options for API calls, configuring the HTTP context
	 * with appropriate language and service user settings
	 *
	 * @param asServiceUser Whether to make the request as a service user
	 * @param reqOptions Request options to be modified
	 * @param ctx Optional HTTP context
	 */
	public prepareRequest(
		asServiceUser: boolean,
		reqOptions?: RequestOptions,
		ctx?: HttpContext,
	): void {
		if (!asServiceUser || !reqOptions) {
			return;
		}

		const dsConfig = this.store.selectSnapshot(ConfigurationState.dsConfiguration);
		let context = ctx || new HttpContext();

		// The data returned from rooms must be in the language of the resource and not of the service user.
		context = context.set(LANG_TOKEN, dsConfig?.locale).set(SERVICEUSER_TOKEN, true);
		reqOptions.context = context;
	}
}
